var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatCursivei = function SvgChatCursivei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.388 16h-.98a.418.418 0 0 1 0-.836h.63l1.084-6.328h-.443a.42.42 0 0 1-.408-.418.41.41 0 0 1 .408-.418h1.913a.42.42 0 0 1 .408.418.41.41 0 0 1-.408.418h-.63l-1.1 6.328h.455a.42.42 0 0 1 .408.418.41.41 0 0 1-.404.418z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatCursivei);
export default ForwardRef;